import { SxProps, Theme } from '@mui/material';

export const getMilestoneSelectorStyles = (): SxProps<Theme> => ({
     display: 'flex',
     gap: 2,
     alignItems: 'center',
});

export const getAddMilestoneButtonStyles = (): SxProps<Theme> => ({
     alignSelf: 'center',
     marginTop: '8px',
}); 